import React, {useEffect} from 'react'
import {AspectRatioBox, Box} from '@chakra-ui/core'
import {api} from '../../infra/http/remote'

type SpallaStatsEventDetail = {
  uid: string;
  currentTime: number;
  duration: number;
  ended: boolean;
  paused: boolean;
  played: number;
  playedIntervals: Array<{ start: number; end: number }>;
  playedPercent: number;
};

interface SambaPlayerProps {
    reference: string
    contentId?: string
    view?: {
        progress: number
        watched: boolean
    }
    modalPlayer?: boolean
}

const SambaPlayer = ({reference, contentId, view, modalPlayer}: SambaPlayerProps) => {
    const idPlayer = modalPlayer ? 'modalPlayer' : 'player'
    let watched = view ? view.watched || false : false;

    useEffect(() => {
        init();

        return () => {
            window.removeEventListener("spalla_player_stats", handleStats);
            window.removeEventListener("spalla_player_ended", handleEnded);
        };
    }, []);

    const getPlayer = async () => {
        return new Promise((resolve) => {
            resolve((window as any).Spalla);
        });
    }

    const getSettingMediaKey = (): string => {
        const data = JSON.parse(localStorage.getItem('settings'))
        const value = data.filter(item => item.name === 'sambavideos_playerKey')
        return value.length ? value[0].value : ''
    }

    const clearPlayer = () => {
        const item = window.document.getElementById(idPlayer)
        if (item) {
            item.innerHTML = ''
        }
    }

    const dispatchActionView = async (currentProgress: number, playedPercent: number): Promise<void> => {
        if (contentId && currentProgress > view.progress) {
            if (Math.round(playedPercent) > 0) {
                await api.post('/user_collection_views', {
                    content: contentId,
                    percent: Math.round(playedPercent) || 100,
                    progress: currentProgress
                })
            }
        }
    }

    const handleStats = async (e: Event) => {
        const event = e as CustomEvent<SpallaStatsEventDetail>;
        const { currentTime, duration } = event.detail;
        const playedPercent = (currentTime / duration) * 100;

        if (currentTime > 1 && Math.round(playedPercent) <= 50 && currentTime % 10 === 0) {
            await dispatchActionView(currentTime, Math.round(playedPercent));
        } else if (currentTime > 1 && Math.round(playedPercent) > 50 && !watched) {
            watched = true;
            await dispatchActionView(duration, 100);
        }
    };

    const handleEnded = async (event: Event) => {
        initPlayerConfig();
        (window as typeof globalThis).Spalla.reloadSpallaConfig()
        // @ts-ignore
        await dispatchActionView(event.detail.duration, 100);
    };

    const addEventListener = (): void => {
        window.addEventListener("spalla_player_stats", handleStats, false);
        window.addEventListener("spalla_player_ended", handleEnded);
    }

    const initPlayerConfig = () => {
        const playerKey = getSettingMediaKey();

        (window as typeof globalThis).Spalla = (window as typeof globalThis).Spalla || {};
        (window as typeof globalThis).Spalla.config = {
            element: '#' + idPlayer,
            stream: reference,
            autoplay: false,
            bar: true,
            search: false,
            audioplayer: false,
            offline: false,
            pip: true,
            t: (view?.progress && !view.watched) ? view.progress : 0,
            info: false,
            subtitlePosition: 'inner',
            aid: playerKey,
        };
    }

    const init = () => {
        clearPlayer();

        initPlayerConfig();

        const existingScript = document.querySelector('script[src="https://beyond.spalla.io/player/js/spalla-player.js"]');
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://beyond.spalla.io/player/js/spalla-player.js';
            script.async = true;
            script.onload = () => {
                addEventListener();
            };
            document.body.appendChild(script);
        } else {
            (window as typeof globalThis).Spalla.reloadSpallaConfig()
            addEventListener();
        }
    }

    return (
        <>
            <AspectRatioBox ratio={16 / 9}>
                <Box id={idPlayer}/>
            </AspectRatioBox>
        </>
    )
}

export default SambaPlayer
